const DECORATION_COSTS = {
  embroidery: 12.69,
  screen: 6.65
};

const calculateUnbundledPrice = (basePrice, decorationMethod) => {
  const decorationCost = DECORATION_COSTS[decorationMethod] || 0;
  const finalPrice = parseFloat(basePrice - decorationCost);

  return finalPrice;
};

export default calculateUnbundledPrice;
